import memoize from 'lodash/memoize'

const __DEV__ = process.env.NODE_ENV === 'development'

export default memoize(name => {
    return (__DEV__ ? process.env : window)[name]
})
